export default "__VITE_ASSET__Ba9cW88m__"